class AbandonmentTracking {
  constructor($form, submitButtonId) {
    this.$form = $form;
    this.submittedSuccessfully = false;
    this.changed = false;
    this.fieldNamesHistory = [];
    this.submitButton = $(`#${submitButtonId}`);

    this.handleEvents();
    this.listenToBeforeUnloadEvent();
  }

  /**
   * Returns the last field name in the field name history array.
   */
  getLastEditedFieldName() {
    return this.fieldNamesHistory[this.fieldNamesHistory.length - 1];
  }

  handleEvents() {
    this.$form.on('input', (e) => {
      const fieldName = $(e.target).attr('name');

      this.changed = true;

      // Only add the field name into the history if it's not the same as the previous field name.
      if (this.getLastEditedFieldName() !== fieldName) {
        this.fieldNamesHistory.push(fieldName);
      }
    });

    // TODO: replace this with form submition check

    this.submitButton.on('click', () => {
      this.submittedSuccessfully = true;
    });
  }

  addEvent() {
    /**
     * This push an object contains abandonment information to the GA
     *
     * @param eventAction - The name of last edited elements in the form will be passed through here.
     * @param eventHistory - An array of the name of user interacted form elements will be passed through here, like ['user-first-name', 'user-last-name', 'user-first-name'].
     */
    window.dataLayer &&
      window.dataLayer.push({
        event: 'formAbandonment',
        eventCategory: 'Form Abandonment',
        eventAction: this.getLastEditedFieldName(),
        formEventId: 'gadonationsubmit',
        eventHistory: this.fieldNamesHistory,
      });
    document.dispatchEvent(
      new CustomEvent('GDformAbandonment', {
        detail: {
          lastField: this.getLastEditedFieldName(),
          eventHistory: this.fieldNamesHistory,
          formName: 'gadonationsubmit',
        },
      }),
    );
  }

  listenToBeforeUnloadEvent() {
    window.addEventListener('beforeunload', () => {
      if (this.changed === true && this.submittedSuccessfully === false) {
        this.addEvent();
      }
    });
  }
}

export default AbandonmentTracking;
